import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '40px 0',
  },
  title: {
    fontFamily: fonts.din2014Demi,
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-3'],
    lineHeight: anatomy['size-36'],
  },
  headerActions: {
    display: 'flex',
    gap: anatomy['size-12'],
  },
  tooltipText: {
    display: 'block',
    width: '151px',
    color: colors.primaryInverseText,
    fontSize: typography['fontSizeCaption-3'],
    lineHeight: `12px`,
  },
  tooltipContainer: {
    ':not(#__unused__) > div': {
      padding: anatomy['size-8'],
    },
  },
});
